"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BILLING_READ_ONLY = exports.PLAN_LIMIT = exports.EXPIRY_REMINDER_DAYS = exports.ORDER_WARNING_PERCENTS = exports.GRACE_DAYS = exports.TRIAL_DAYS = exports.BILLING_PLAN_KEYS = exports.BILLING_PLANS = void 0;
exports.BILLING_PLANS = {
    pilot: { price: 0, limits: { orders: 1000, staff: 2, retailers: 50, salesmen: 10 } },
    starter: { price: 1499, limits: { orders: 1000, staff: 2, retailers: 50, salesmen: 5 } },
    growth: { price: 2999, limits: { orders: 2000, staff: 5, retailers: 150, salesmen: 15 } },
    pro: { price: 5999, limits: { orders: 3000, staff: 10, retailers: 400, salesmen: 50 } },
};
exports.BILLING_PLAN_KEYS = Object.keys(exports.BILLING_PLANS);
/** A new business's free pilot. */
exports.TRIAL_DAYS = 30;
/** After the trial or paid period ends, this many days before the business turns read-only. */
exports.GRACE_DAYS = 7;
/** The owner is warned when this month's orders reach these shares of the plan's limit. */
exports.ORDER_WARNING_PERCENTS = [80, 100];
/** The owner is emailed this many days before the trial or paid period ends. */
exports.EXPIRY_REMINDER_DAYS = [7, 2];
/** Refusal codes, in the API's `error.code`. */
exports.PLAN_LIMIT = 'PLAN_LIMIT';
exports.BILLING_READ_ONLY = 'BILLING_READ_ONLY';
//# sourceMappingURL=billing.js.map